import { Controller } from "@hotwired/stimulus"

// Drives the TV pairing screen.
//
// 1. On connect, persist the freshly-issued device token to localStorage so
//    subsequent boots of the WebView shell skip pairing.
// 2. Poll /tv/status with the token every few seconds. Once the server reports
//    the Beacon is paired, reload /tv carrying the token so the server renders
//    the assigned dashboard.
export default class extends Controller {
  static values = {
    token: String,
    interval: { type: Number, default: 4000 }
  }

  connect() {
    if (this.tokenValue) {
      try {
        window.localStorage.setItem("win.beacon.token", this.tokenValue)
      } catch (e) {
        // Private mode / storage disabled — polling still works for this session.
      }
      this.poll()
    }
  }

  disconnect() {
    this.stopPolling()
  }

  stopPolling() {
    if (this.pollTimer) {
      clearTimeout(this.pollTimer)
      this.pollTimer = null
    }
  }

  poll() {
    fetch(`/tv/status?token=${encodeURIComponent(this.tokenValue)}`, {
      headers: { Accept: "application/json" }
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.paired) {
          this.stopPolling()
          this.loadDashboard()
        } else if (data.state === "unknown") {
          // The beacon was revoked or vanished — restart from a clean /tv.
          this.stopPolling()
          window.location.assign("/tv")
        } else {
          this.pollTimer = setTimeout(() => this.poll(), this.intervalValue)
        }
      })
      .catch(() => {
        // Transient network error — keep trying.
        this.pollTimer = setTimeout(() => this.poll(), this.intervalValue)
      })
  }

  loadDashboard() {
    window.location.assign(`/tv?token=${encodeURIComponent(this.tokenValue)}`)
  }
}
